// extracted by mini-css-extract-plugin
export var caption = "Figure-module--caption--3baf8";
export var captionBox = "Figure-module--captionBox--a87f5";
export var content = "Figure-module--content--98e6a";
export var image = "Figure-module--image--1fb84";
export var label = "Figure-module--label--76673";
export var root = "Figure-module--root--bd51a";
export var title = "Figure-module--title--cfa06";